<h1 mat-dialog-title>Sincronizar leads Meta</h1>

<mat-dialog-content [formGroup]="form">
  <div class="container">
    <div class="row">
      @if (!result) {
        <div class="col-12">
          <p class="hint">Consulta los formularios de Lead Ads de Meta e importa los leads que aún no estén en el CRM.</p>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Horas hacia atrás</mat-label>
            <input matInput type="number" formControlName="hours" min="1" max="720" />
            <mat-hint>Máximo 720 horas (30 días)</mat-hint>
          </mat-form-field>
          <p class="last-sync">{{ lastSyncedLabel() }}</p>
        </div>
      } @else {
        <div class="col-12 summary">
          <p class="summary-title">Resumen (últimas {{ result.hours }} h)</p>
          <ul>
            <li>Vistos: {{ result.seen }}</li>
            <li>Creados: {{ result.created }}</li>
            <li>Omitidos (ya existían): {{ result.skipped }}</li>
            <li>Fallidos: {{ result.failed }}</li>
          </ul>
          <p class="last-sync">{{ lastSyncedLabel() }}</p>
          @if (result.failures.length > 0) {
            <p class="hint-warning">Detalle de fallos:</p>
            <ul class="failures">
              @for (failure of result.failures; track failure.leadgen_id) {
                <li>{{ failure.leadgen_id }} — {{ failure.reason }}</li>
              }
            </ul>
          }
        </div>
      }

      @if (error_message) {
        <div class="col-12">
          <p class="hint-error">{{ error_message }}</p>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!result) {
    <button mat-button type="button" (click)="close()" [disabled]="syncing">Cancelar</button>
    <button mat-flat-button color="accent" type="button" (click)="submit()" [disabled]="!form.valid || syncing">
      <mat-icon style="margin-right: 8px">sync</mat-icon>
      {{ syncing ? 'Sincronizando…' : 'Sincronizar' }}
    </button>
  } @else {
    <button mat-flat-button color="accent" type="button" (click)="close()">Cerrar</button>
  }
</mat-dialog-actions>
